import styled, { CSSObject } from 'styled-components';

interface CollapsibleStyledProps {
  width?: number;
  open?: boolean;
  sx?: CSSObject;
}

const CollapsibleWrapperStyled = styled.div<CollapsibleStyledProps>(
  ({ theme, open, sx }) => {
    const styleSheet: CSSObject = {
      transition: `${theme.transition.duration}`,
      height: '100%',
      ...sx,
    };

    if (open) {
      styleSheet.display = 'block';
    }

    if (!open) {
      styleSheet.display = 'none';
    }

    return styleSheet;
  },
);

export { CollapsibleWrapperStyled };
